import { render, staticRenderFns } from "./vouchbrowerfilter.vue?vue&type=template&id=b8b90812&scoped=true&"
import script from "./vouchbrowerfilter.vue?vue&type=script&lang=js&"
export * from "./vouchbrowerfilter.vue?vue&type=script&lang=js&"
import style0 from "./vouchbrowerfilter.vue?vue&type=style&index=0&id=b8b90812&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8b90812",
  null
  
)

export default component.exports